"use strict";

var screenersImport = require("../../screeners");

var utils = require("../../screeners/utils");

var likelihood = ["Not at all likely", "1", "2", "3", "4", "5 - Neutral", "6", "7", "8", "9", "Extremely likely"];
var ROIoptions = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];

var likelihoodFn = function likelihoodFn(n) {
  return n * 100 / (likelihood.length - 1);
};

var slider = ["0", "1", "2", "3", "4", "5", "6", "7"];
var surveyscreeners = [utils.screeners.PSS4];
var questions = screenersImport.expandscreeners([{
  prompt: "This self-assessment takes 5 minutes to complete, and will provide you " + "with a snapshot of your mental fitness alongside global averages. Your responses  " + "are stored securely, confidential between you and your coach, and will never be used " + "to identify you to a third party.",
  type: "multi",
  options: [],
  intro: true,
  optional: true,
  aggregated: true,
  batteryId: "survey"
}, // Demographics
{
  prompt: "What is your gender?",
  type: "multi",
  options: ["Male", "Female", "Other"],
  key: "gender",
  eval: function _eval(n, q) {
    return q.options[n];
  },
  batteryId: "survey"
}, {
  prompt: "What is your age?",
  extraText: "",
  type: "single",
  optional: false,
  key: "age",
  eval: function _eval(n) {
    return n;
  },
  batteryId: "survey"
}, {
  prompt: "Which one best describes your role?",
  extraText: "",
  type: "multi",
  options: ["Administration", "Finance & Accounting", "Marketing", "Engineering & Technology", "Legal", "Monitoring & Analytics", "Human Resources", "Research", "Trades & Labour", "Other"],
  optional: false,
  key: "industry",
  eval: function _eval(n, q) {
    return q.options[n];
  },
  batteryId: "survey"
}, // Company support and cohesion
{
  prompt: "In the past week, to what extent have you felt supported by " + "your company?",
  extraText: "",
  type: "slider",
  options: ["Not at all supported", "1", "2", "3", "4", "5", "6", "7", "8", "9", "Completely supported"],
  key: "companySupport",
  eval: function _eval(n) {
    return 10 * n;
  },
  batteryId: "survey"
}, {
  prompt: "In the past week, to what extent have you felt supported by " + "your manager?",
  extraText: "",
  type: "slider",
  options: ["Not at all supported", "1", "2", "3", "4", "5", "6", "7", "8", "9", "Completely supported"],
  key: "managerSupport",
  eval: function _eval(n) {
    return 10 * n;
  },
  batteryId: "survey"
}, {
  prompt: "In the past week, how united has your team been in trying to " + "reach its goals for performance?",
  extraText: "",
  type: "slider",
  options: ["Not at all united", "1", "2", "3", "4", "5", "6", "7", "8", "9", "Completely united"],
  key: "cohesion",
  eval: function _eval(n) {
    return 10 * n;
  },
  batteryId: "survey"
}, // NPS
{
  prompt: "How likely are you to recommend your company to a friend as a " + "great place to work?",
  extraText: "",
  type: "slider",
  options: likelihood,
  key: "npsWork",
  eval: likelihoodFn,
  batteryId: "survey"
}, // Sleep
{
  prompt: "Please rate the quality of your sleep over the last week.",
  extraText: "",
  type: "slider",
  options: ["Worst possible sleep", "1", "2", "3", "4", "5 - Neutral", "6", "7", "8", "9", "Best possible sleep"],
  key: "sleepQuality",
  eval: function _eval(n) {
    return 10 * n;
  },
  batteryId: "survey"
}].concat(surveyscreeners, [{
  prompt: "How many days in the last week did you miss work due to mental or" + " physical health reasons (e.g. stress, fatigue, illness)?",
  options: slider,
  aggregated: true,
  key: "roiAbsenteeismDays",
  type: "dayslider",
  specific: true,
  batteryId: "",
  eval: function _eval(n) {
    return n;
  }
}, {
  prompt: "On how many days in the last week did you feel so impaired by stress," + " that even though you went to work, your productivity was reduced?",
  options: slider,
  aggregated: true,
  type: "dayslider",
  key: "roiPresenteeismDays",
  specific: true,
  batteryId: "ROI_HPQ_3_DAYSLIDE",
  eval: function _eval(n) {
    return n;
  }
}, {
  prompt: "On how many days in the past week have you felt so stressed or" + " frustrated with work that you considered changing jobs?",
  options: slider,
  aggregated: true,
  key: "roiTurnoverRiskDays",
  type: "dayslider",
  specific: true,
  batteryId: "ROI_HPQ_3_DAYSLIDE",
  eval: function _eval(n) {
    return n;
  }
}, {
  prompt: "On a scale from 0 to 10, where 0 is the worst job performance " + "anyone could have at your job and 10 is the best performance anyone " + "could have, how would you rate your overall job performance on the " + "days you worked in the past 4 weeks?",
  options: ROIoptions,
  aggregated: true,
  key: "roiPerfomance",
  type: "dayslider",
  specific: true,
  batteryId: "ROI_HPQ_3_DAYSLIDE",
  eval: function _eval(n) {
    return n;
  }
}]));

var analysis = function analysis(answers, numeric) {
  if (!answers) return null;
  var results = {};
  results.scales = {};
  results.humanReadable = {};
  surveyscreeners.forEach(function (battery) {
    var batteryResults = screenersImport.extractResults(questions, answers, battery);
    var scales = screenersImport.getScalesByBatteryId(battery);

    if (scales) {
      results.scales = Object.assign(results.scales, scales);
    }

    var batteryHumanReadable = batteryResults.humanReadable;
    delete batteryResults.humanReadable;
    results = Object.assign(results, batteryResults);
    results.humanReadable = Object.assign(results.humanReadable, batteryHumanReadable);
    results;
  });
  questions.forEach(function (q, i) {
    if (!q.key) return;

    if (numeric) {
      results[q.key] = answers[i];
    } else {
      results[q.key] = q.eval(answers[i], q);
      results.humanReadable[q.prompt] = q.eval(answers[i], q);
    }
  });
  return results;
};

module.exports = {
  questions: questions,
  analysis: analysis
};